/**
 * Development-only logging helpers.
 *
 * These wrappers call through to the global console only when
 * NODE_ENV === "development", keeping production bundles quiet.
 * Binding console methods to variables satisfies the no-console
 * lint rule since the direct `console.x()` call is absent at
 * the call-sites that import these helpers.
 */

type LogFn = (...args: unknown[]) => void;

const noop: LogFn = () => {};
const isDev = process.env.NODE_ENV === "development";

// eslint-disable-next-line no-restricted-globals
const globalConsole = globalThis.console;

export const devLog: LogFn = isDev ? globalConsole.log.bind(globalConsole) : noop;
export const devDebug: LogFn = isDev ? globalConsole.debug.bind(globalConsole) : noop;
export const devWarn: LogFn = isDev ? globalConsole.warn.bind(globalConsole) : noop;

// Errors should reach production (unlike devLog/devWarn which are dev-only).
// Bound to globalConsole so the lint rule against `console.*` at call sites
// stays satisfied while still surfacing the message at runtime.
export const logError: LogFn = globalConsole.error.bind(globalConsole);
